module.exports = __webpack_public_path__ + "img/no-item-small.e26cd174.jpg";